import {Component, Input} from '@angular/core';
import {AppState} from "../../../store/store";
import {Store} from "@ngrx/store";
import {reportOpenDownloadDialog} from "../../../store/report/report.actions";
import {Observable} from "rxjs";
import {selectReportDownloadLoading} from "../../../store/report/report.selectors";

@Component({
  selector: 'app-report-download-button',
  templateUrl: './report-download-button.component.html',
  styleUrls: ['./report-download-button.component.scss']
})
export class ReportDownloadButtonComponent {
  @Input() public disabled: boolean;
  @Input() public reportData: any;

  public readonly loading$: Observable<boolean> = this._store.select(selectReportDownloadLoading);

  constructor(
    private readonly _store: Store<AppState>
  ) {}

  public downloadFile(format: string, separator: string = ','): void {
    this._store.dispatch(reportOpenDownloadDialog({ format, separator }));
  }
}
